window.lang2 =
{
  "general": {
    "404": {
      "title": "404 Page Not Found",
      "subtitle": "The page you requested does not exist",
      "subtext_html": "Click [link]HERE[\/link] to continue shopping."
    },
    "meta": {
      "tags": "Tagged \"{{ tags }}\"",
      "page": "Page {{ page }}"
    },
    "breadcrumbs": {
      "home": "Home",
      "home_link_title": "Back to the frontpage"
    },
    "newsletter_form": {
      "title": "Newsletter",
      "newsletter_email": "Email Address",
      "submit": "Submit",
      "text": "Enter your e-mail Address",
      "noitice": "Don’t show this popup again",
      "go": "Go!",
      "ok": "ok",
      "subscribe": "subscribe"
    },
    "search": {
      "no_results_html": "No results for \"{{ terms }}\"",
      "results_for_html": "Search results for \"{{ terms }}\":",
      "title": "Search for products on our site",
      "placeholder": "Search...",
      "submit": "Search",
      "category": "Select category",
      "info_search": "Start typing to see products you are looking for.",
      "not_found": "No products found",
      "view_results": "View all results"
    },
    "date": {
      "year_text": "years",
      "month_text": "months",
      "week_text": "weeks",
      "day_text": "days",
      "year_singular_text": "year",
      "month_singular_text": "month",
      "week_singular_text": "week",
      "day_singular_text": "day",
      "hour_text": "Hours",
      "min_text": "Mins",
      "sec_text": "Secs",
      "hour_singular_text": "Hour",
      "min_singular_text": "Min",
      "sec_singular_text": "Sec"
    },
    "modal": {
      "wishlist_text": "Excl. postage",
      "continue_shopping": "Continue",
      "go_to_wishlist": "My Wishlist",
      "add_to_wishlist_message": "Just added to your wishlist:",
      "cart_text": "Excl. postage",
      "go_to_cart": "Go to cart page",
      "add_to_cart_message": "You've just added this product to the cart:",
      "qty": "Qty:",
      "total": "Total:"
    }
  },
  "header": {
    "settings": {
      "login": "Sign in or Create an Account",
      "register": "Register",
      "logout": "Logout",
      "my_account": "My Account",
      "wishlist": "My Wishlist",
      "compare": "Compare",
      "currency": "Currency",
      "newsletter_signup": "Newsletter Signup",
      "language": "Your Languages",
      "daily_deal": "Daily deal",
      "blog": "Blog",
      "links": "Links",
      "shop": "Shop"
    },
    "topbar": {
      "my_cart": "My cart",
      "search": "Search"
    },
    "vat_popup": {
      "title": "What customer are you:",
      "business": "Professional",
      "customer": "Private"
    }
  },
  "footer": {
    "links": {
      "title": "Shortcuts",
      "contact": "Contact",
      "about": "About us",
      "partner": "Become a partner",
      "legal": "Legal notices",
      "GTCS": "GTCS",
      "blog": "Atome3D Blog"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "{{ date }}",
      "by_admin": "By {{ author }}",
      "older_post": "Older Post",
      "newer_post": "Newer Post",
      "tags": "Tags",
      "read_more": "Read more",
      "share_post": "Share: "
    },
    "comments": {
      "title": "Leave a comment",
      "name": "Name *",
      "email": "Email *",
      "message": "Message *",
      "post": "Post comment",
      "moderated": "Please note, comments must be approved before they are published",
      "success_moderated": "Your comment was posted successfully. We will publish it in a little while, as our blog is moderated.",
      "success": "Your comment was posted successfully! Thank you!",
      "comments_with_count": {
        "one": "{{ count }} comment",
        "other": "comments ({{ count }})"
      }
    },
    "sidebar": {
      "recent_articles": "Recent Posts",
      "categories": "Blog Categories",
      "video": "Latest Video",
      "tags": "Tag Cloud",
      "search_placeholder": "Search posts here..."
    },
    "related_posts": "Related Posts"
  },
  "cart": {
    "general": {
      "title": "Shopping Cart",
      "remove": "Remove",
      "edit": "Edit",
      "note": "Special instructions for seller",
      "note_placeholder": "Digicode, building, entrance...",
      "carttotals": "Cart Totals",
      "subtotal": "Subtotal (excl. VAT)",
      "subtotal_VAT": "Subtotal ",
      "grandtotal": "Total (incl. VAT)",
      "includingVAT": "Including VAT",
      "tax_at_checkout": "Total price incl. VAT will be shown at checkout.",
      "shipping_at_checkout": "Checkout with Multiple Addresses",
      "continue": "Continue Shopping",
      "update": "Update Shopping Cart",
      "checkout": "Proceed to checkout",
      "checkout_forbidden": "Checkout Forbidden",
      "checkout_forbidden_title": "Checkout Forbidden, check your items!",
      "vat_number": "VAT Number",
      "add_vat": "Add VAT Number",
      "edit_vat": "Edit VAT Number",
      "empty": "Your cart is currently empty",
      "thousands": "Thousands of products await you!",
      "continue_browsing": "Shop some Goods",
      "close_cart": "Close Cart",
      "shipping_calculator_error_message": "Error: Please enter right shipping information",
      "shipping_calculator_success_many_rates": {
        "there_are": "There are",
        "shipping_rates_available_for": "shipping rates available for this destination:",
        "starting_at": ", starting at"
      },
      "shipping_calculator_success_one_rate": "There is one shipping rate available for",
      "shipping_calculator_success_no_rate": "There is no shipping rate available for this order and destination.",
      "shipping_calculator_success_at": "at",
      "promo_question": "Do you have a coupon code?",
      "promo_answer": "Apply it in the next step in the « coupon code » box.",
      "check_terms_of_sales": "I have read, understood and accepted the [link]Term of Sales[\/link].",
      "read_terms_of_sales": "Please check this box if you wish to continue."
    },
    "roadmap": {
      "cart": "Cart",
      "informations": "Informations",
      "shipping": "Shipping",
      "payment": "Payment"
    },
    "header": {
      "view_cart": "View cart",
      "checkout": "Checkout",
      "total": "Total:",
      "total_numb": "item(s)",
      "no_item": "You have no items in your shopping cart.",
      "remove_this_item": "Remove item"
    },
    "label": {
      "product": "Product Name",
      "price": "Unit Price",
      "quantity": "Qty",
      "update_cart": "Update Cart",
      "remove": "Remove",
      "total": "Total"
    },
    "shipping": {
      "title": "Calculate Shipping",
      "title_cart": "Estimate Cart Shipping",
      "title_form": "Enter your destination:",
      "country": "Country",
      "state": "State",
      "zip": "Zip\/Postal Code",
      "submit_button": "Estimate shipping",
      "submit_button_empty_cart": "Your cart is Empty!",
      "submit_button_when_calculating": "Calculating..."
    },
    "informations": {
      "note": "Note:",
      "notes": "Notes:",
      "ondemand": "Item on demand: can't be checked out",
      "ondemand_info": "Your cart contains at least one \"On Demand\" item, so it cannot be validated!",
      "preorder": "Item in preorder",
      "preorders": "Items in preorder",
      "preorder_info": "You have a pre-ordered item in your Cart.",
      "preorders_info": "You have some pre-ordered items in your Cart.",
      "incoming_date": "Your order will be shipped from ",
      "no_incoming_date": "Your order will be sent when the product is available.",
      "no_incoming_dates": "Your order will be sent when all products are available.",
      "ship7to15days": "Item shipped within 7\/15 days",
      "ship7to15dayss": "Items shipped within 7\/15 days",
      "ship7to15days_info": "You have an item shipped within 7\/15 days in your cart.",
      "ship7to15dayss_info": "You have some items shipped within 7\/15 days in your cart.",
      "ship15days": "Item Shipped within 15 days"
    }
  },
  "collections": {
    "general": {
      "title": "List Collections",
      "all_of_collection": "All {{ collection }}",
      "no_matches": "Sorry, there are no products in this collection",
      "link_title": "Browse our {{ title }} collection",
      "grid_view": "Grid view",
      "list_view": "List view",
      "view_all": "view all",
      "shop_the_collection": "Shop The Collection",
      "items_with_count": {
        "one": "{{ count }} Products",
        "other": "{{ count }} Products"
      },
      "clear": "Clear",
      "refine_by": "Refine By:",
      "clear_all": "Clear all",
      "filter": "Filter",
      "showing": "Showing",
      "of": "of",
      "previous": "Previous",
      "next": "Next",
      "show_more": "Load More",
      "loading": "Loading",
      "no_more_product": "No more product",
      "quickview": "Quick View"
    },
    "sidebar": {
      "categories": "Categories",
      "shopby": "Shop by",
      "tags": "Tag Cloud"
    },
    "sorting": {
      "title": "Sort by:",
      "featured": "Featured",
      "best_selling": "Best Selling",
      "az": "Name, A-Z",
      "za": "Name, Z-A",
      "price_ascending": "Price, low to high",
      "price_descending": "Price, high to low",
      "date_descending": "Date, new to old",
      "date_ascending": "Date, old to new",
      "limit_16": "16",
      "limit_22": "22",
      "limit_44": "44",
      "limit_all": "All"
    },
    "limiter": {
      "title": "Show",
      "limit_16": "16",
      "limit_22": "22",
      "limit_44": "44",
      "limit_all": "All"
    },
    "onboarding": {
      "modal_title": "This page will show all of your store's products",
      "no_products_html": "There are no products yet, but once you begin adding them they will show up here regardless if they are in a collection.",
      "add_product": "Add Product"
    },
    "onepage": {
      "seemore": "See More"
    }
  },
  "contact": {
    "form": {
      "title": "Leave a ",
      "title_after": "Message",
      "name": "Name",
      "first_name": "First Name",
      "company": "Company",
      "business_line": {
        "title": "Business Line",
        "line1": "Agriculture",
        "line2": "Dental",
        "line3": "Jewellery",
        "line4": "Aeronautics",
        "line5": "Sports",
        "line6": "Architecture \/ Design",
        "line7": "Fablabs",
        "line8": "Private individual",
        "line9": "Professional",
        "line10": "Association \/ Art \/ Culture",
        "line11": "Banking \/ Insurance \/ Finance",
        "line13": "Trade \/ Distribution",
        "line14": "Communication \/ Advertising \/ Media",
        "line15": "Council",
        "line16": "Construction \/ Building \/ Real Estate",
        "line17": "Teaching \/ Training \/ Research",
        "line18": "Industry",
        "line19": "IT \/ Telecom",
        "line20": "Cosmetics \/ Pharmaceutical \/ Health \/ Beauty",
        "line21": "Public Sector",
        "line22": "Luxury",
        "line23": "Business Services",
        "line24": "Tourism \/ Leisure \/ Catering",
        "line25": "Transport \/ Logistics"
      },
      "address1": "Address",
      "address2": "Address Supplement",
      "zip_code": "Zip Code",
      "city": "City",
      "country": "Country",
      "email": "Email",
      "phone": "Phone",
      "chorus": "Public Administration (Choruspro)",
      "no": "No",
      "yes": "Yes",
      "message": "Message",
      "comment": "Comment",
      "cart": "Your Cart",
      "infos": "Your Informations",
      "send": "Send Message",
      "totalItem": "For a total of {{ items_nb }} item",
      "totalItems": "For a total of {{ items_nb }} items",
      "submit": "Submit",
      "post_success": "Thanks for contacting us. We'll get back to you as soon as possible."
    }
  },
  "customer": {
    "account": {
      "title": "My Account",
      "details": "Account Details",
      "cancelled": "Cancelled",
      "view_addresses": "View Addresses",
      "return": "Return to Account Details",
      "download_order": "Download this Order"
    },
    "activate_account": {
      "title": "Activate Account",
      "subtext": "Create your password to activate your account.",
      "password": "Password",
      "password_confirm": "Confirm Password",
      "submit": "Activate Account",
      "cancel": "Decline Invitation"
    },
    "addresses": {
      "title": "My Address",
      "title_multi": "My Addresses",
      "default": "Default",
      "add_new": "Add a New Address",
      "edit_address": "Edit address",
      "first_name": "First Name",
      "last_name": "Last Name",
      "company": "Company",
      "address1": "Address1",
      "address2": "Address2",
      "city": "City",
      "country": "Country",
      "province": "Province",
      "zip": "Postal\/Zip Code",
      "phone": "Phone",
      "set_default": "Set as default address",
      "add": "Add Address",
      "update": "Update Address",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete",
      "delete_message": "Are you sure you wish to delete this address?"
    },
    "login": {
      "heading": "Login or Create an Account",
      "page_title": "Login",
      "title": "Registered Customers",
      "content": "If you have an account with us, please log in.",
      "email": "Email Address",
      "password": "Password",
      "forgot_password": "Forgot your password?",
      "sign_in": "Sign In",
      "log_in": "Log in",
      "cancel": "Return to Store",
      "guest_title": "Continue as a guest",
      "guest_continue": "Continue",
      "register": "New Customers",
      "register_content": "By creating an account with our store, you will be able to move through the checkout process faster, store multiple shipping addresses, view and track your orders in your account and more.",
      "register_button": "Create an Account"
    },
    "logout": {
      "title": "Logout"
    },
    "orders": {
      "title": "Order History",
      "order_number": "Order",
      "date": "Date",
      "payment_status": "Payment",
      "fulfillment_status": "Fulfillment",
      "total": "Total",
      "invoice": "Invoice",
      "none": "You haven't placed any orders yet.",
      "financial_status": {
        "pending": "Pending",
        "authorized": "Authorized",
        "paid": "Paid",
        "partially_paid": "Partially Paid",
        "partially_paid_short": "Partially Paid",
        "refunded": "Refunded",
        "partially_refunded": "Partially Refunded",
        "partially_refunded_short": "Part. Refunded",
        "voided": "Voided"
      },
      "fulfill_status": {
        "fulfilled": "Fulfilled",
        "unfulfilled": "Unfulfilled",
        "partial": "Partially fulfilled",
        "partial_short": "Part. fulfilled"
      }
    },
    "order": {
      "title": "Order {{ name }}",
      "date": "Placed on ",
      "cancelled": "Order Cancelled on {{ date }}",
      "cancelled_reason": "Reason: {{ reason }}",
      "billing_address": "Billing Address",
      "payment_status": "Payment Status",
      "shipping_address": "Shipping Address",
      "fulfillment_status": "Fulfillment Status",
      "cancelled_status": "Cancelled",
      "discount": "Discount",
      "shipping": "Shipping",
      "tax": "Tax",
      "product": "Product",
      "sku": "SKU",
      "price": "Price (excl. tax)",
      "quantity": "Quantity",
      "total": "Total (incl. tax)",
      "total_exvat": "Total (excl. tax)",
      "fulfilled_at": "Fulfilled {{ date }}",
      "subtotal": "Subtotal (excl. tax)",
      "download": "Download",
      "status": "Status"
    },
    "recover_password": {
      "title": "Reset your password",
      "email": "Email",
      "email_placeholder": "Enter your Email...",
      "submit": "Submit",
      "cancel": "Back to Login",
      "subtext": "We will send you an email to reset your password.",
      "success": "We've sent you an email with a link to update your password."
    },
    "reset_password": {
      "title": "Reset account password",
      "subtext": "Enter a new password for account: {{ email }}",
      "password": "New Password",
      "password_confirm": "Confirm Password",
      "submit": "Reset Password",
      "error": "Error when resetting the password."
    },
    "register": {
      "page_title": "Register",
      "title": "Create Account",
      "title_form": "Personal Information",
      "first_name": "First Name",
      "last_name": "Last Name",
      "email": "Email",
      "confirm_email": "Confirm Email",
      "email_arror": "Your email address is not correct!",
      "email_compare": "Email addresses do not match!",
      "password": "Password",
      "submit": "Submit",
      "required": "Required Fields",
      "cancel": "Return to Store",
      "message": "Please enter the following information to create your account."
    }
  },
  "homepage": {
    "sections": {
      "frontpage_title": "Frontpage Collection",
      "featured_title": "Featured Collections",
      "news_title": "Latest News"
    },
    "onboarding": {
      "modal_title": "Almost there...",
      "no_products_html": "You have no products in your Frontpage collection. This placeholder will appear until you <a href=\"\/admin\/collections?tutorial=Frontpage\">add a product to this collection<\/a>.",
      "add_product": "Add a Product",
      "product_title": "Example Product Title",
      "no_collections_html": "You don't have any collections to show here. <a href=\"\/admin\/custom_collections\">Add some collections<\/a> to go along with the default Frontpage.",
      "add_collection": "Add a Collection",
      "collection_title": "Example Collection Title"
    }
  },
  "layout": {
    "navigation": {
      "menu": "Menu"
    },
    "drawers": {
      "browse": "Browse",
      "close_menu": "Close menu"
    },
    "cart": {
      "title": "Cart",
      "items_count": {
        "one": "item",
        "other": "items"
      }
    },
    "customer": {
      "account": "Account",
      "logged_in_as_html": "Logged in as {{ first_name }}",
      "log_out": "Log out",
      "log_in": "Log in",
      "create_account": "Create account"
    },
    "footer": {
      "social_title": "Get Connected",
      "newsletter_title": "Newsletter",
      "accepted_payments": "Accepted Payments"
    }
  },
  "wish_list": {
    "general": {
      "wishlist": "Wishlist",
      "add_to_wishlist": "Add to wishlist",
      "browse_wishlist": "Browse wishlist",
      "product": "Product",
      "price": "Price",
      "remove": "has removed from wishlist",
      "quantity": "Quantity",
      "options": "Options",
      "no_item": "There is no items in wishlist box",
      "item_exist": "is exist in wishlist",
      "item_added": "has added to wishlist successful"
    }
  },
  "compare_list": {
    "general": {
      "compare": "Comparing box",
      "add_to_compare": "Add to compare",
      "price": "Price",
      "product": "Product",
      "remove": "has removed from comparing box",
      "quantity": "Quantity",
      "options": "Options",
      "no_item": "There is no items in comparing box",
      "item_exist": "is exist in compare",
      "item_added": "has added to comparing box successful",
      "features": "Features",
      "actions": "Actions"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Previous Product",
      "next_product_html": "Next Product &rarr;",
      "from_text_html": "{{ price }}",
      "sale_price": "Sale price",
      "regular_price": "Regular price",
      "related_products": "Also Purchased",
      "sale": "Sale",
      "show_all": "Show all",
      "show_more": "Load more",
      "no_more_product": "No more products"
    },
    "product": {
      "quickview": "quick view",
      "sold_out": "Discover",
      "on_quotation": "By Quotation",
      "on_request": "By Request",
      "on_sale": "On Sale",
      "on_sale_from_html": "{{ price }}",
      "unit_price": "i.e. ",
      "unavailable": "Unavailable",
      "by_quotation": "On Quotation Only",
      "by_request": "On Request Only",
      "compare_at": "Compare at",
      "quantity": "Qty",
      "add_to_cart": "Add to Cart",
      "view_product": "View Product",
      "ask_for_quotation": "Request a Quote",
      "ask_for_request": "Make a Request",
      "select_options": "Select Options",
      "tab_title_description": "More Information",
      "tab_title_review": "Reviews",
      "share": "Share:",
      "availability": "Availability:",
      "price_out_VAT": "Price excluding VAT",
      "ex_vat": "excl. VAT",
      "price_incl_VAT": "Price including VAT",
      "incl_vat": "incl. VAT",
      "sku": "SKU: ",
      "product_in_stock": "Product available",
      "product_in_restock": "Restocking",
      "in_stock_short": "Available",
      "in_restock_short": "Restocking",
      "only": "Only ",
      "in_stock": "[StockValue] in stock",
      "out_of_stock": "Out Of Stock",
      "out_of_stock_short": "Restocking",
      "in_preorder": "In pre-order",
      "in_preorder_short": "Pre-order",
      "ship7to15days": "Product available - Shipped within 7 to 15 days",
      "ship7to15days_short": "Shipped within 7 to 15 days",
      "ship15days": "Shipped within 15 days of order",
      "ship15days_short": "Ship. 15d.",
      "many_in_stock": "Many In Stock",
      "product_type": "Product Type:",
      "product_vendor": "Vendor:",
      "count_down": "Limited-Time Offers, End in:",
      "incoming-date": "Available from ",
      "incoming-tooltip_html": "Date given as an indication,\nmay be subject to change.",
      "preorder_now": "Preorder Now",
      "suggested_items": {
      	"title": "Products frequently purchased together",
        "total_price": "Total price:",
        "buy_product": "Add this item to cart",
        "buy_products": "Add these {{ count }} items to cart",
        "this_product": "This product:",
        "none_selected": "Select the items to add together to cart."
      }
    },
    "buy_detail": {
      "mandat_admin": "Accepted Administrative Mandate",
      "fast_delivery": "Ordered before 2pm, shipped today!",
      "stock_in_france": "Stock located in France",
      "tooltip": "More info here"
    },
    "payment": {
      "rhythm_your_payment": "Rhythm up your payment!",
      "title": "Pay in 4 times",
      "first": "Today",
      "second": "In 1 month",
      "next": "In {{ count }} months",
      "bill_fee": "(Prices incl. VAT - Shipping cost not included)"
    },
    "restock_alert": {
      "notify_title": "Notify Me!"
    },
    "labels": {
      "preorder": "Pre-order Now",
      "newproduct": "New Product",
      "ecoresponsible_html": "Eco-Responsible"
    },
    "social_share": {
      "share": "share",
      "facebook": "Share on Facebook",
      "twitter": "Share on Twitter",
      "linkedin": "Share on Linkedin",
      "pinterest": "Share on Pinterest",
      "mail": "Share by Email"
    },
    "specs": {
      "title": "Technical information & data",
      "general": {
        "title": "General Informations",
        "type": {
          "title": "Type",
          "desktop": "Desktop 3D Printer",
          "industrial": "Industrial 3D Printer"
        },
        "techno": { 
          "title": "Technology",
          "FDM": "Fused deposition modeling (FDM)",
          "LCD": "Resin (LCD)",
          "DLP": "Resin (DLP)",
          "SLA": "Resin (SLA)",
          "SLS": "Selective Laser Sintering (SLS)"
        },
        "form_factor": {
          "title": "Form Factor",
          "corexy": "CoreXY",
          "cartesian": "Cartesian",
          "delta": "Delta",
          "belt": "Belt",
          "polar3d": "Polar 3D"
        },
        "assembly": {
          "title": "Assembly",
          "assembled": "Assembled",
          "pre_assembled": "Pre-assembled",
          "kit": "Kit"
        },
        "materials": "Printable Materials"
      },
      "techs": {
        "title": "Technical Specifications",
        "build_volume": "Build Volume",
        "extruder": {
          "title": "Extrusion",
          "mode": {
            "title": "Extrusion Head",
            "single": "Single",
            "double": "Double",
            "dual": "Dual",
            "single_optDouble": "Single (Double optional)",
            "single_optDual": "Single (Dual optional)"
          },
          "type": {
            "title": "Extrusion Type",
            "direct": "Direct Drive",
            "bowden": "Bowden System"
          },
          "diameter": "Nozzle Diameter",
          "max_temp": "Nozzle Max Temp",
          "filament": "Filament Diameter"
        },
        "mask": {
          "title": "Light System",
          "light_source": {
            "title": "Light Source",
            "source_wav": "{{ value1 }} (wavelength {{ value2 }} nm)"
          },
          "screen": {
            "title": "Masking Screen",
            "mono": "Monochrome",
            "color": "Color"
          }
        },
        "measures": {
          "title": "Mesures",
          "precision_xy": "Precision X/Y",
          "precision_z": "Precision Z",
          "bed_temp": "Print Bed max Temp.",
          "speed": {
            "title": "Print Speed",
            "resin": "{{ value1 }} sec / layer, Max {{ value2 }} mm/h"
          }
        },
        "interfaces": {
          "title": "Interfaces",
          "connectivity": "Connectivity",
          "control": {
            "title": "Control Screen",
            "touch_color": "{{ value }}\" Color Touchscreen",
            "notouch_color": "{{ value }}\" Color Screen, manual interface",
            "touch_mono": "{{ value }}\" Mono Touchscreen",
            "notouch_mono": "{{ value }}\" Mono Screen, manual interface"
          }
        }
      },
      "properties" : {
        "title": "Properties",
        "heated_bed": "Heated Build Plate",
        "particle_filter": "Particle Filter",
        "level_sensor": "Levelling Sensor",
        "resume": "Resume after Power loss",
        "levelling" : {
          "title": "Build Plate Levelling",
          "manual": "Manual",
          "assisted": "Assisted",
          "auto": "Automatic",
          "touch_points": ", {{ value }} points leveling"
        },
        "power_consume": "Power Consume",
        "sound_level": "Sound Level"
      },
      "software": {
        "title": "Software",
        "firmware": "Firmware",
        "slicers": "Recommended slicer(s)",
        "files": "File Format"
      },
      "footprint": {
        "title": "Footprint",
        "printer_sizes": "Printer Sizes",
        "printer_weight": "Printer Weight",
        "package_sizes": "Package Sizes",
        "package_weight": "Package Weight"
      },
      "sizes_info": "(W × D × H)"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "Here's your {{ value }} gift card for {{ shop }}!",
      "subtext": "Here's your gift card!",
      "disabled": "Disabled",
      "expired": "Expired on {{ expiry }}",
      "active": "Expires on {{ expiry }}",
      "redeem": "Use this code at checkout to redeem your gift card",
      "shop_link": "Start shopping",
      "print": "Print"
    }
  },
  "date_formats": {
    "month_day_year": "%B %d, %Y"
  },
  "pagefly": {
    "products": {
      "product": {
        "regular_price": "Regular price",
        "sold_out": "Sold out",
        "unavailable": "Unavailable",
        "on_sale": "Sale",
        "quantity": "Quantity",
        "add_to_cart": "Add to cart",
        "back_to_collection": "Back to {{ title }}",
        "view_details": "View details"
      }
    },
    "article": {
      "tags": "Tags:",
      "all_topics": "All topics",
      "by_author": "by {{ author }}",
      "posted_in": "Posted in",
      "read_more": "Read more",
      "back_to_blog": "Back to {{ title }}"
    },
    "comments": {
      "title": "Leave a comment",
      "name": "Name",
      "email": "Email",
      "message": "Message",
      "post": "Post comment",
      "moderated": "Please note, comments must be approved before they are published",
      "success_moderated": "Your comment was posted successfully. We will publish it in a little while, as our blog is moderated.",
      "success": "Your comment was posted successfully! Thank you!",
      "comments_with_count": {
        "one": "{{ count }} comment",
        "other": "{{ count }} comments"
      }
    },
    "password_page": {
      "login_form_message": "Enter store using password:",
      "login_form_password_label": "Password",
      "login_form_password_placeholder": "Your password",
      "login_form_submit": "Enter",
      "signup_form_email_label": "Email",
      "signup_form_success": "We will send you an email right before we open!",
      "password_link": "Enter using password"
    }
  }
}